// navigation.service.ts
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ReturnUrlService {

  constructor(private router: Router, private activatedRoute: ActivatedRoute) {}

  navigateToReturnUrlOrDefault(defaultRoute: string): void {
    const returnUrl = this.activatedRoute.snapshot.queryParams['returnUrl'];
    if (returnUrl) {
      this.router.navigate([returnUrl]);
    } else {
      this.router.navigateByUrl(defaultRoute);
    }
  }
}
